import React from 'react';
import { BookOpen, Heart, Info, Mail, User, ShieldCheck } from 'lucide-react';
import { CONTACT_EMAIL, CONTACT_MAILTO } from '../constants/contact';


export default function ProfileMenu({ onSelect }) {
  return (
    <div className="absolute right-0 top-12 w-52 max-w-[calc(100vw-1.5rem)] rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-2xl p-2 z-40">

      <button
        onClick={() => onSelect('cadastro')}
        className="w-full flex items-center gap-2 text-left px-3 py-2.5 rounded-xl text-sm font-bold text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
      >
        <User size={15} />
        Conta da API
      </button>

      <button
        onClick={() => onSelect('api')}
        className="w-full flex items-center gap-2 text-left px-3 py-2.5 rounded-xl text-sm font-bold text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
      >
        <BookOpen size={15} />
        Docs da API
      </button>

      <button
        onClick={() => onSelect('admin')}
        className="w-full flex items-center gap-2 text-left px-3 py-2.5 rounded-xl text-sm font-bold text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
      >
        <ShieldCheck size={15} />
        Backoffice
      </button>

      <div className="my-1 h-px bg-gray-100 dark:bg-gray-700" />

      <button
        onClick={() => onSelect('about')}
        className="w-full flex items-center gap-2 text-left px-3 py-2.5 rounded-xl text-sm font-bold text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
      >
        <Info size={15} />
        Sobre
      </button>

      <button
        onClick={() => onSelect('support')}
        className="w-full flex items-center gap-2 text-left px-3 py-2.5 rounded-xl text-sm font-bold text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
      >
        <Heart size={15} />
        Apoie o Projeto
      </button>

      <a
        href={CONTACT_MAILTO}
        className="w-full flex items-center gap-2 text-left px-3 py-2.5 rounded-xl text-sm font-bold text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
      >
        <Mail size={15} />
        <span className="min-w-0">
          <span className="block">Contato</span>
          <span className="block truncate text-[10px] font-bold text-gray-400 dark:text-gray-500">{CONTACT_EMAIL}</span>
        </span>
      </a>
    </div>
  );
}
